<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="900px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            style="right:50px; top:40px;"
            class="mt-5 mr-0"
            v-on="on"
            absolute
            dark
            small
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar plano de contas</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="dialogShow = false">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">{{setTitleForm(formData.id )}}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0 dialogMinHeightCard">
        <v-form ref="rgrExpForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs4 px-3>
                <v-select
                  class="selectOverflowHiden"
                  :rules="$store.state.formRules.requiredSelect"
                  v-model="formData.condominium_id"
                  :disabled="userAccPlan.length ? true : false"
                  :items="condominiums"
                  item-text="name_fantasy"
                  item-value="id"
                  @change="getExpensesGroups"
                  label="Selecione o condomínio"
                ></v-select>
              </v-flex>
              <v-flex xs4 px-3>
                <v-select
                  class="selectOverflowHiden"
                  v-model="formData.expenseGroup_Id"
                  :items="expensesGroups"
                  :disabled="!formData.condominium_id"
                  item-text="name"
                  item-value="code_sis"
                  label="Selecione um grupo de despesas"
                  @change="getAccountPlans"
                >
                  <template
                    v-slot:selection="{ item }"
                  >Cod.: {{item.code_user}} - {{item.name_user}}</template>
                  <template v-slot:item="{ item }">Cod.: {{item.code_user}} - {{item.name_user}}</template>
                </v-select>
              </v-flex>
              <v-flex xs4 px-3>
                <v-select
                  class="selectOverflowHiden"
                  return-object
                  v-model="formData.accountPlan_Id"
                  :items="accountPlans"
                  :disabled="!formData.expenseGroup_Id"
                  item-text="name"
                  item-value="id"
                  append-icon="library_add"
                  @click:append="addAaccountPlan(formData.accountPlan_Id)"
                  label="Selecione um plano"
                >
                  <template v-slot:selection="{ item }">Cod.: {{item.code}} - {{item.name}}</template>
                  <template v-slot:item="{ item }">Cod.: {{item.code}} - {{item.name}}</template>
                </v-select>
              </v-flex>
              <h4
                class="mb-2 grey--text text--darken-1 pl-4"
                v-if="userAccPlan.length"
              >Meus planos de contas</h4>
              <p
                v-if="!userAccPlan.length"
                style="width:100%"
                class="body-2 text-xs-center pt-5"
              >Selecione um condomínio, um grupo de despesas e um plano de conta para criar o seu padrão.</p>
              <v-layout
                v-for="(expense, i) in userAccPlan "
                :key="i"
                row
                wrap
                mx-3
                px-3
                py-2
                mb-3
                grey
                roundBox
                lighten-4
              >
                <v-flex xs12 class="text-xs-left pb-0">
                  <small>
                    <b
                      class="blue-grey--text text--darken-1"
                    >Grupo de despeas cod. {{expense.expDfCode}} - {{expense.expDfName}}</b>
                  </small>
                </v-flex>
                <v-flex xs12 class="text-xs-left pt-0">
                  <code class="pa-1 codeClass mr-2">
                    <b>Plano {{expense.defCode}} - {{expense.defName}}</b>
                  </code>
                  <span class="caption pl-2 grey--text text--darken-1">Padrão no sistema</span>
                  <!-- <span><b>JARDINAGEM E PAISAGISMO</b></span> -->
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="expense.code"
                    label="Meu código"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
                <v-flex xs7 class="pl-5">
                  <v-text-field
                    v-model="expense.description"
                    label="Descrição"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
                <v-flex xs1 class="pt-3">
                  <v-btn flat icon color="primary" @click="removeAccountPlan(expense.default_id)">
                    <v-icon style="font-size:24px;">delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="dialogShow = false">Cancelar</v-btn>
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const rgrExpDefaultForm = {
  name: "",
  condominium_id: "",
  accountPlan_Id: null,
  expenseGroup_Id: null,
  permissions_id: [],
};
export default {
  name: "profilesForm",
  components: {},
  props: {
    addButton: Boolean,
    closeForm: Function,
    reloadUserAccountPlans: Function,
    dialog: Boolean,
    editFormData: Object,
  },
  data: function () {
    return {
      userAccPlan: [],
      noChangeCondominium: false,
      expensesGroups: [],
      accountPlans: [],
      dialogShow: false,
      condominium_id: "",
      condominiums: [],
      viewForm: false,
      permissionsList: [],
      formData: { ...rgrExpDefaultForm },
      validForm: true,
    };
  },
  computed: {},
  watch: {
    dialogShow: function (val) {
      //console.log(val);
      if (val) {
      } else {
        this.resetDialog();
      }
    },
  },
  mounted() {
    this.getComdominiums();
    //this.getExpensesGroups();
    this.getPermissions();
  },
  methods: {
    setTitleForm(id) {
      let returnTitle;
      if (id) {
        returnTitle = "Editar plano de contas";
      } else {
        returnTitle = "Criar plano de contas";
      }
      if (this.viewForm) {
        returnTitle = "Visualização";
      }
      return returnTitle;
    },
    resetDialog() {
      this.formData = { ...rgrExpDefaultForm };
      this.$refs.rgrExpForm.resetValidation();
      this.userAccPlan = [];
      this.accountPlans.map((exp) => {
        exp.disabled = false;
        return exp;
      });
    },
    removeAccountPlan(id) {
      var index = this.userAccPlan.findIndex((exp) => exp.default_id === id);
      this.userAccPlan.splice(index, 1);
      var ind = this.accountPlans.findIndex((expDef) => expDef.id === id);
      this.accountPlans[ind].disabled = false;
    },
    addAaccountPlan(item) {
      console.log("------------", item);
      if (!item) {
        return;
      }
      item.disabled = true;
      var ind = this.expensesGroups.findIndex(
        (expDef) => expDef.code_sis === item.default_id
      );
      console.log(this.expensesGroups[ind]);
      let createNewLine = async () => {
        let newLine = {};
        newLine.default_id = item.id;
        newLine.condominium_id = this.formData.condominium_id;
        newLine.expDfCode = this.expensesGroups[ind].code_sis;
        newLine.expDfName = this.expensesGroups[ind].name_sis;
        newLine.defCode = item.code;
        newLine.defName = item.name;
        newLine.code = "";
        newLine.description = "";
        await this.userAccPlan.unshift({ ...newLine });
        console.log(this.userAccPlan);
      };
      createNewLine().then((_) => {
        this.formData.expenseGroup_Id = "";
        this.formData.accountPlan_Id = "";
        this.$refs.rgrExpForm.resetValidation();
      });
    },
    openForm() {
      this.dialogShow = true;
    },
    getComdominiums() {
      let obj = {
        url: "/api/condominium",
        query: "",
        method: "get",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        this.condominiums = response.data;
      });
    },
    getAccountPlans() {
      console.log(">>>>>>");
      let id = this.formData.expenseGroup_Id;
      let obj = {
        url: "/api/planAccount/list_plan/" + id,
        query: "",
        method: "get",
      };
      this.$store
        .dispatch("request/doRequest", obj)
        .then((response) => {
          this.accountPlans = response.data.map((accPlan) => {
            accPlan.disabled = false;
            return accPlan;
          });
        })
        .then((_) => {
          if (this.userAccPlan.length) {
            let arr = this.userAccPlan;
            this.accountPlans.map((line) => {
              for (let i = 0; i < arr.length; i++) {
                if (arr[i].defCode == line.code) {
                  line.disabled = true;
                }
              }
            });
          }
        });
    },
    getExpensesGroups() {
      let obj = {
        url: "/api/expenseGroup/list_gruop/" + this.formData.condominium_id,
        query: "",
        method: "get",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        this.expensesGroups = response.data;
      });
    },
    getPermissions() {
      let obj = {
        url: "/api/permission",
        query: "",
        method: "get",
        noLoader: true,
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        this.permissionsList = response.data;
      });
    },
    doSave() {
      if (!this.$refs.rgrExpForm.validate()) {
        return;
      }
      let query = {
        plan: this.userAccPlan.map((data) => {
          let plan = {};
          plan.default_plan_id = data.default_id;
          plan.expenseGroup_id = data.expDfCode;
          plan.code = data.code;
          plan.description = data.description;
          plan.condominium_id = data.condominium_id;
          return plan;
        }),
      };
      console.log(query);

      //return;
      // {
      //       "default_plan_id":1,
      //       "expenseGroup_id": 1,
      //       "condominium_id": 1,
      //       "description": "122234",
      //       "code": "2221"
      //   }
      let obj = {
        url: "/api/planAccount",
        query: query,
        method: "post",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        let obj = {
          message: `${response.data.message}`,
          title: "Sucesso",
          callback: (_) => {
            this.reloadUserAccountPlans();
          },
          type: "success",
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", obj);
      });
    },
  },
};
</script>

<style>
.permissionTitle.red--text,
.permissionTitle.red--text::before {
  content: "*";
  color: #f44336 !important;
}
.codeClass {
  background: #fff;
  color: darkblue;
}
.codeClassExpenseDetails {
  background: #fff;
  color: rgb(120, 120, 120);
}
.roundBox {
  border-radius: 5px;
}

.dialogMinHeightCard {
  min-height: 300px;
}
/* .selectOverflowHiden .v-select__selections {
  white-space: nowrap;
  overflow: hidden;
} */
.selectOverflowHiden input {
  /* display: none; */
  position: absolute !important;
}
</style>
